var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.announcement
    ? _c("div", { staticClass: "global-announcement-wrapper" }, [
        _c("div", {
          staticClass: "global-announcement-spacer",
          style: { height: _vm.bannerHeight + "px" }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "banner",
            staticClass: "global-announcement-banner",
            style: _vm.bannerStyle
          },
          [
            _c("i", { staticClass: "bullhorn icon" }),
            _vm._v(" "),
            _c("span", { staticClass: "global-announcement-text" }, [
              _vm._v(_vm._s(_vm.announcement.message))
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-145ff5ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-145ff5ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalAnnouncement.vue
// module id = VWYD
// module chunks = 1